import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import Logo from "./Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { t } = useTranslation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/auth", { replace: true }); return; }
    const sessionId = decodeURIComponent(match[1]);
    const exchange = async () => {
      try {
        const res = await fetch(`${API}/auth/session?session_id=${sessionId}`, { credentials: "include" });
        if (res.ok) { const userData = await res.json(); login(userData); navigate("/dashboard", { replace: true }); }
        else { navigate("/auth", { replace: true }); }
      } catch { navigate("/auth", { replace: true }); }
    };
    exchange();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "#111111" }}>
      <div className="text-center space-y-5">
        <Logo size="xl" className="mx-auto" />
        <p className="font-medium text-white">{t("auth.signingIn")}</p>
        <div className="flex justify-center gap-1.5 pt-1">
          {[0, 1, 2].map(i => (
            <div key={i} className="w-2 h-2 rounded-full animate-bounce" style={{ background: "#c084fc", animationDelay: `${i * 0.15}s` }} />
          ))}
        </div>
      </div>
    </div>
  );
}
